/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * New Device Metadata
 * @export
 * @interface CognitoAuthenticationResultNewDeviceMetadata
 */
export interface CognitoAuthenticationResultNewDeviceMetadata {
    /**
     * Device Group Key
     * @type {string}
     * @memberof CognitoAuthenticationResultNewDeviceMetadata
     */
    deviceGroupKey: string;
    /**
     * Device Key
     * @type {string}
     * @memberof CognitoAuthenticationResultNewDeviceMetadata
     */
    deviceKey: string;
}

/**
 * Check if a given object implements the CognitoAuthenticationResultNewDeviceMetadata interface.
 */
export function instanceOfCognitoAuthenticationResultNewDeviceMetadata(value: object): value is CognitoAuthenticationResultNewDeviceMetadata {
    if (!('deviceGroupKey' in value) || value['deviceGroupKey'] === undefined) return false;
    if (!('deviceKey' in value) || value['deviceKey'] === undefined) return false;
    return true;
}

export function CognitoAuthenticationResultNewDeviceMetadataFromJSON(json: any): CognitoAuthenticationResultNewDeviceMetadata {
    return CognitoAuthenticationResultNewDeviceMetadataFromJSONTyped(json, false);
}

export function CognitoAuthenticationResultNewDeviceMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitoAuthenticationResultNewDeviceMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceGroupKey': json['deviceGroupKey'],
        'deviceKey': json['deviceKey'],
    };
}

export function CognitoAuthenticationResultNewDeviceMetadataToJSON(value?: CognitoAuthenticationResultNewDeviceMetadata | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'deviceGroupKey': value['deviceGroupKey'],
        'deviceKey': value['deviceKey'],
    };
}

